<template>
  <app-layout title="Логистика">
    <div class="restriction" v-if="restricted">
      У Вас недостаточно прав для просмотра этой страницы
    </div>
    <div class="stores" v-else>
      <div
        class="stores__loader"
        v-if="loading">
        <v-progress-circular
          :size="70"
          :width="7"
          color="grey"
          indeterminate
        ></v-progress-circular>
      </div>

      <template v-else>
        <h2 class="header headline font-weight-medium">Список магазинов</h2>
        <div class="stores_button_menu">
          <v-btn
            class="stores__refresh-button"
            color="info"
            @click="handleRefresh"
          >
            Обновить список
          </v-btn>
          <v-btn
            class="stores__refresh-button"
            color="info"
            @click="handleGetXLSX"
          >
            Устройства в XLSX
          </v-btn>
          <v-btn
            class="stores__refresh-button"
            color="info"
            @click="handleGetGradeXLSX"
          >
            Грейды в XLSX
          </v-btn>
        </div>
        <h3 class="subheader subheading font-weight-medium">Высокий приоритет</h3>
        <div class="stores__table">
          <v-data-table
            class="data-table"
            :headers="tableHeaders"
            :items="prioritizedList"
            hide-actions
          >
            <template
              slot="items"
              slot-scope="{ item: { storeId, org, name, city, ordersLength, oldestOrder, code } }"
            >
              <tr class="data-table__row" @click="handleTableRowClick(storeId)">
                <td>{{ org }}</td>
                <td>{{ name }}</td>
                <td>{{ code }}</td>
                <td>{{ city }}</td>
                <td class="text-xs-center">
                  <span :class="[
                    'data-table__highlighted-cell',
                    {
                      'data-table__highlighted-cell_light': ordersLength > 5 && ordersLength < 10,
                      'data-table__highlighted-cell_strong': ordersLength >= 10,
                    }
                  ]">
                    {{ ordersLength }}
                  </span>
                </td>
                <td class="text-xs-center">
                  <span :class="[
                    'data-table__highlighted-cell',
                    {
                      'data-table__highlighted-cell_light': oldestOrder > 10 && oldestOrder < 15,
                      'data-table__highlighted-cell_strong': oldestOrder >= 15,
                    }
                  ]">
                    {{ oldestOrder }} дней
                  </span>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>

        <h3 class="subheader subheading font-weight-medium">Все магазины</h3>
        <div class="stores__table">
          <v-data-table
            class="data-table"
            :headers="tableHeaders"
            :items="stores"
            hide-actions
          >
            <template
              slot="items"
              slot-scope="{ item: { storeId, org, name, city, ordersLength, oldestOrder, code } }"
            >
              <tr class="data-table__row" @click="handleTableRowClick(storeId)">
                <td>{{ org }}</td>
                <td>{{ name }}</td>
                <td>{{ code }}</td>
                <td>{{ city }}</td>
                <td class="text-xs-center">
                  <span :class="[
                    'data-table__highlighted-cell',
                    {
                      'data-table__highlighted-cell_light': ordersLength > 5 && ordersLength < 10,
                      'data-table__highlighted-cell_strong': ordersLength >= 10,
                    }
                  ]">
                    {{ ordersLength }}
                  </span>
                </td>
                <td class="text-xs-center">
                  <span :class="[
                    'data-table__highlighted-cell',
                    {
                      'data-table__highlighted-cell_light': oldestOrder > 10 && oldestOrder < 15,
                      'data-table__highlighted-cell_strong': oldestOrder >= 15,
                    }
                  ]">
                    {{ oldestOrder }} дней
                  </span>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </template>
    </div>
  </app-layout>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Visibility from 'visibilityjs';
import AppLayout from '../../components/AppLayout.vue';

export default {
  name: 'stores',
  components: {
    AppLayout,
  },
  data() {
    return {
      tableHeaders: [
        {
          text: 'Организация',
          value: 'org',
        },
        {
          text: 'Название магазина',
          value: 'name',
        },
        {
          text: 'Код магазина',
          value: 'code',
        },
        {
          text: 'Город',
          value: 'city',
        },
        {
          text: 'Количество заявок',
          value: 'ordersLength',
          align: 'center',
        },
        {
          text: 'Максимальный срок хранения',
          value: 'oldestOrder',
          align: 'center',
        },
      ],
    };
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapState('stores', ['stores', 'loading']),
    restricted() {
      return this.user.type < 2;
    },
    prioritizedList() {
      return this.stores.filter(
        ({ ordersLength, oldestOrder }) => ordersLength >= 10 || oldestOrder >= 14,
      );
    },
  },
  methods: {
    ...mapActions('stores', ['fetchStores','handleGetXLSX','handleGetGradeXLSX']),

    handleTableRowClick(id) {
      this.$router.push({ name: 'store', params: { id } });
    },

    async handleRefresh() {
      await this.fetchStores();
    },
  },
  async created() {
    await this.fetchStores();

    this.refreshInterval = Visibility.every(1000 * 60 * 10, this.fetchStores);
    // this.visibilityHandler = Visibility.change((e, state) => {
    //   if (state === 'visible') {
    //     this.fetchStores();
    //   }
    // });
  },
  async beforeDestroy() {
    Visibility.stop(this.refreshInterval);
    Visibility.unbind(this.visibilityHandler);
  },
};
</script>

<style lang="sass">
  .restriction
    margin: auto

  .header
    margin-bottom: 30px

  .subheader
    margin-bottom: 7px
    line-height: 19px

  .stores
    align-self: flex-start
    display: flex
    flex-direction: column
    max-width: 1215px
    width: 100%
    min-height: 100%
    margin: 0 auto
    padding: 40px

    &__loader
      margin: auto

    &__table
      margin-bottom: 24px

    &_button_menu
      align-self: flex-end


  .data-table
    &__row
      cursor: pointer

    &__highlighted-cell
      display: inline-block
      padding: 0 6px
      line-height: 26px
      border-radius: 5px

      &_strong
        background-color: #0089D7
        color: #fff

      &_light
        background: rgba(0, 137, 215, 0.66)
        color: #fff
</style>
